<template>
    <div class="wrapper-all">
        <div class="wrapper">
            <div
                class="terms-and-conditions mb-3"
                v-on:scroll="handleScroll"
                v-if="isUrdu"
            >
                <h4>
                    These terms and conditions (“Terms and Conditions”) regulate
                    the online services offered by JS Investments Limited also
                    referred as “JSIL” for the Funds to the Users.
                </h4>

                <p>
                    Whereas, JSIL is offering the digital account opening
                    services and online transactions in compliance with the
                    regulatory requirements pursuant to the constitutive
                    documents of the Funds, to facilitate investment and
                    divestment by Unit Holders/ Account Holders and to make
                    adequate arrangements for receiving and processing
                    applications in this regard.
                </p>
                <h5>1. General</h5>
                <p>
                    1. By receiving the automatically generated password for the
                    first log in to the online services, the User is deemed to
                    have acknowledged that it has read, reviewed, understood and
                    unconditionally and irrevocably accepted all these Terms and
                    Conditions. These Terms and Conditions form the contract
                    between the User and JSIL for the use of the online
                    services. These Terms and Conditions are in addition to and
                    not in derogation of the Constitutive Documents for the
                    relevant Fund(s) of which the User is a Unit Holder and
                    shall be construed in accordance with the applicable law and
                    regulations from time to time. JSIL shall have the absolute
                    discretion to amend or supplement any of these Terms and
                    Conditions pertaining to the online services at any time and
                    shall be notified by hosting the same on the website of JSIL
                    or in any other manner as decided by JSIL. Such amended
                    Terms and Conditions stipulated by JSIL will thereupon apply
                    to and be binding on the User. The User shall be responsible
                    for regularly reviewing these Terms and Conditions,
                    including amendments thereto as may be posted on the website
                    of JSIL.
                </p>
                <p>
                    2. The User shall have no objection to JSIL verifying the
                    User’s identity before registering the User for online
                    services. The User shall register for online services by
                    providing such personal details as shall be required by JSIL
                    from time to time for the purpose of effecting the
                    registration. JSIL shall validate the personal details
                    provided by the User to enable the User to register for the
                    online services. In the event that any of the details
                    provided by the User are not in conformity with the details
                    available with JSIL, JSIL shall, at its sole discretion,
                    reject the registration of the User and the User may be
                    required to update its personal details with JSIL in the
                    manner prescribed by JSIL. In the event of incorrect
                    submission of details by the User or the User failing the
                    KYC procedures, its account may also be blocked and any
                    payment made shall be returned or the Units purchased shall
                    be redeemed, as the case may be, to the User by transferring
                    the amount to the account from which the payment was made
                </p>
                <p>
                    3. In case of any discrepancy in the details of any
                    transaction carried out in respect of the User's online
                    services, the User shall be obliged to intimate to JSIL
                    thereof in writing within 7 (seven) days of receipt of the
                    statement of account. In the event of the User failing to
                    intimate, the statement of account will be deemed to be
                    correct and accepted by the User.
                </p>
                <p>
                    4. JSIL is authorized to provide any information or details
                    relating to the User, its account(s) of the relevant Fund(s)
                    or its Account(s) to any third person so far as is necessary
                    to give effect to any instructions or to comply with any
                    order of the Court or of any competent/ statutory authority
                    or as is required under applicable law
                </p>
                <p>
                    5. The User hereby confirms that the User shall solely be
                    responsible for conducting all activities by using the
                    Services and Password over the online services and the same
                    will be deemed to have emanated from such User. The User
                    agrees that all Instructions transmitted by using the online
                    services, shall be deemed to be written instructions and
                    agrees not to dispute or challenge the validity or
                    enforceability of any such instruction on the grounds that
                    such instructions were not written documents and hereby
                    waives any such right the User may have at law. In addition,
                    such Instructions are considered original documents and the
                    User agrees not to challenge the admissibility of any such
                    instruction on the grounds that it is made in electronic or
                    oral form.
                </p>
                <p>
                    6. The User represents to JSIL that the User has full power
                    to perform its obligations in accordance with these Terms
                    and Conditions and availing the online services.
                </p>
                <p>
                    7. The User agrees that the online services is being
                    provided by JSIL for the User’s benefit and in discharge of
                    the duty imposed upon JSIL to facilitate investment and
                    divestment by Unit Holders and to make adequate arrangements
                    for receiving and processing applications in this regard.
                    The User further acknowledges that JSIL has the power to
                    provide the online services pursuant to the Constitutive
                    Documents and the transactions envisaged by the online
                    services along with these Terms and Conditions shall be
                    legal, valid and binding and in accordance with the
                    provisions of the Constitutive Documents.
                </p>
                <p>
                    8. In order to have a valid transaction, where the User is
                    not resident in Pakistan or the person to whom the User
                    intends to transfer its Units, is not resident in Pakistan,
                    the User agrees to ensure that the information on the
                    Proceeds Realization Certificate(s) matches the details of
                    the User’s online services.
                </p>
                <p>
                    9. The User agrees to avoid transfer of cash or third
                    payments to JSIL Funds accounts as Cash and third Party
                    Payments are NOT acceptable for investment in JSIL Funds.
                </p>
                <p>
                    10. The Unit Holder accepts that all transactions effected
                    through use of the online services shall be binding jointly
                    and severally on all joint Unit Holders.
                </p>
                <p>
                    11. Statutory Details - Users may obtain constitutive
                    documents along with application forms from the offices of
                    JSIL or can be downloaded from the company website
                    accessible at www.jsil.com.
                </p>
                <p>
                    12. Risk Factors - All investments in mutual funds and
                    securities are subject to market risks and the Net Asset
                    Value (NAV) of the Scheme(s) may go up or down depending on
                    the factors and forces affecting the securities markets.
                    There can be no assurance that the objectives of the
                    Scheme(s) will be achieved. Past performance of the Sponsor,
                    AMC, Mutual Fund or any associates of the Sponsor/AMC does
                    not indicate the future performance of the Scheme(s) of the
                    Mutual Fund.
                </p>
                <h5>2. Service</h5>
                <p>
                    1. The User acknowledges that the price, rates, conditions
                    and charges applicable for a Service shall be in accordance
                    with the applicable Constitutive Documents and susceptible
                    to change in accordance with the terms thereof.
                </p>
                <p>
                    2. The User acknowledges and undertakes that if
                    transaction(s) is submitted after cut off time as mentioned
                    in respective Constitutive Documents of the Funds, that
                    transaction(s) will be processed on next working day and
                    that he/she will not hold JSIL or trustee of the respective
                    Fund for any loss consequent to processing of such
                    transaction(s) on the next working day.
                </p>
                <p>
                    3. The calculation of the NAV for investment and redemption
                    transactions will be done in accordance with the
                    Constitutive Documents.
                </p>
                <p>
                    4. The Unit Holder agrees that number of units shall be
                    issued on realization of investment amounts in Funds bank
                    account(s) as per relevant pricing mechanism of the Fund in
                    accordance with the Constitutive Documents.
                </p>
                <p>
                    5. The User understands that the online services shall be
                    provided at the sole discretion of JSIL who may, at its
                    absolute discretion, alter, suspend or terminate any of the
                    services or online services completely or partially without
                    any notice to the User and without assigning any reasons
                    thereof and the User agrees that JSIL will not be liable for
                    any consequences in connection thereof. JSIL reserves the
                    right, in its sole discretion, to withdraw any or all the
                    Funds from the online services with prior notice published
                    on its website without assigning any reason for such
                    withdrawal of Fund.
                </p>
                <p>
                    6. The User may close his online services by contacting JSIL
                    or providing written instructions to the effect to close the
                    account.
                </p>
                <p>
                    7. The User consents that persons authorized by it may give
                    an Instruction or use a Service on its behalf. The User
                    accepts all risks in connection with such third party use
                    and further and accepts that JSIL shall not be liable in any
                    manner and for any reason whatsoever in connection with such
                    third party use on behalf of the User. In the event of an
                    unauthorized person using a Service or giving an
                    unauthorized Instruction, the User shall inform JSIL of such
                    fact not later than 12 hours after receiving a notification
                    from JSIL that the account has been accessed.
                </p>
                <p>
                    8. Any redemption request would be processed subject to the
                    closing Units available in JSIL's records.
                </p>
                <p>
                    9. In the event that there is insufficient number of Units
                    lying to the Unit Holder’s credit in its account with JSIL
                    or the drawing limit is exhausted or insufficient funds are
                    lying in the Account, no fund transfer will be allowed.
                </p>
                <p>
                    10. Our products and services are offered only in
                    jurisdictions where and when they may be lawfully offered
                    and the material on JSIL website or online services is not
                    intended for use by persons located in or resident in
                    jurisdictions which restrict the distribution of this
                    material by us. Persons accessing these pages are required
                    to inform themselves about and observe any relevant
                    restrictions.
                </p>

                <h5>3. Security and Confidentiality of Information</h5>

                <p>
                    1. The Password selected by the User is confidential in
                    nature and the User confirms that it will keep the Password
                    confidential and will not divulge it to anybody else except
                    for the purpose of using it himself for availing of any
                    facilities as may be offered by JSIL under online services
                    from time to time. The User also agrees to take all possible
                    care to prevent discovery of the Password by any other
                    person. The responsibility for misuse of the Password of the
                    User is solely of the User and JSIL shall not be responsible
                    for the use/misuse of the Password in any manner whatsoever.
                    Accordingly, the User agrees to accept the activities
                    conducted through the use/misuse of or fraudulent use of the
                    Password of the User in the same manner as if such
                    activities were duly authorized by the User itself.
                </p>
                <p>
                    2. The User confirms and assures that it will not share its
                    Password with any person(s). Notwithstanding the aforesaid,
                    in the event of the User sharing its Password with any other
                    person(s), for availing any facilities offered by JSIL under
                    online services, then for such disclosure and any
                    consequences of use / misuse of Password by such person(s),
                    the User shall be solely responsible. JSIL shall never
                    contact the User to inquire about his/her password.
                </p>
                <p>
                    3. The User shall inform JSIL immediately in case its
                    Password becomes known to any other person or is lost. JSIL
                    may in its absolute discretion, issue to the User a new
                    Password on similar terms and conditions or under such terms
                    and conditions as JSIL may deem fit.
                </p>
                <p>
                    4. The User is aware of all security risks including
                    possible third party interception of its account and the
                    content of it account becoming known to third parties. The
                    User accepts that the use of the online services is not the
                    most secure method of accepting and transmitting information
                    and that it involves security hazards and the risk of any
                    loss of information or obtaining of information by any third
                    party will be to its account and JSIL shall, in no way, be
                    held responsible for the same and this shall not be
                    considered as a breach of its or its constituent company
                </p>
                <p>
                    5. A User’s access to online services will be disabled if a
                    wrong Password or identification information is entered
                    successively for 3 times or as decided by JSIL in its sole
                    discretion from time to time.
                </p>
                <p>
                    6. The User shall ensure that the title of its bank account
                    from which investment amount will be paid and to which
                    redemption proceeds will be paid, shall be the same as the
                    title of its online services to achieve an additional level
                    of security.
                </p>

                <h5>4. Online Payments</h5>
                <p>
                    1. The online payment system is provided by JSIL and its
                    third party suppliers. The User warrants that in using the
                    online payment facility it is authorized to use such
                    facility for the payment or payments it is making. JSIL may
                    provide more than one facility for making online payments.
                </p>
                <p>
                    2. JSIL will not be liable if a payment transaction cannot
                    be processed as a result of (i) a legal order prohibiting
                    withdrawals from the Account, (ii) the Account is dormant,
                    closed or has been inactive, (iii) JSIL is otherwise not
                    authorized to debit the Account due to some legal orders,
                    (iv) Units in the accounts are pledged or lien is marked in
                    favour of some pledgee. or (v) the Unit Holder providing an
                    incorrect account number or other incorrect details whether
                    personal or otherwise. The Unit Holder agrees that JSIL
                    shall not be liable for any costs, fees, loss or damage in
                    the event it fails to process an Instruction where payment
                    has been made by using the Transfer in the correct amount or
                    in a timely manner when properly instructed to do so by the
                    Unit Holder, except where (a) the Account has insufficient
                    funds, (b) the funds are subject to legal process or other
                    encumbrance restricting such Transfer or (d) as otherwise
                    provided in instructions by the State Bank of Pakistan.
                </p>
                <p>
                    3. JSIL reserves the right to refuse to honor payment
                    requests that it believes or suspects (rightly or wrongly)
                    are fraudulent or erroneous. The Unit Holder understands,
                    however, that JSIL’s exercise of this right will be in its
                    sole discretion and the Unit Holder should not rely on JSIL
                    to discover or prevent loss as a result of a fraud or
                    erroneous payments.
                </p>

                <h5>5. Liability</h5>
                <p>
                    1. JSIL shall have no obligation to verify the authenticity
                    of any Activity conducted, Service used or Instruction
                    received or purported to have been received from the User
                    other than by means of verification of the Password. The
                    User shall directly contact JSIL for any fraudulent
                    transaction(s) on account of misuse of the online services
                    by a fraudulent individual/party and such issues shall be
                    suitably addressed by JSIL alone in line with its policies
                    and rules. The User agrees that under no circumstances shall
                    JSIL be liable for such fraudulent transactions.
                </p>
                <p>
                    2. The User understands that JSIL disclaims all and any
                    liability, whether direct or indirect, whether arising out
                    of loss of profit or otherwise arising out of any failure or
                    inability by JSIL to honor any instruction from the User for
                    whatsoever reason. The User understands and accepts that
                    JSIL shall not be responsible for any of the risks. The User
                    also accepts that JSIL has disclaimed all liability in
                    respect of the said risks. The Unit Holder accepts that
                    there may be delays in processing Instructions for
                    investment or redemption of Units due to the infrastructure,
                    connectivity and services provided by the network service
                    providers and other factors, including unavailability of
                    funds in the Account or delays by the User’s banks and/or
                    financial institutions. As a result, while the User may give
                    an Instruction before the cut-off timings on a business day,
                    the same may be processed after the cut-off timings and in
                    calculating the NAV, the following business day’s rates
                    shall be applicable. The User shall not hold JSIL liable for
                    any such instance.
                </p>
                <p>
                    3. The User acknowledges that the online services is
                    dependent on the infrastructure, connectivity and services
                    provided by the network service providers and other factors.
                    The User accepts that timeliness, accuracy and readability
                    of SMS/alerts/information shall depend on factors affecting
                    the network service providers. JSIL shall not be liable for
                    non-delivery or delayed delivery of
                    SMS/alerts/instructions/information, payments, error, loss
                    or distortion in transmission of information and
                    Instructions to/from the User.
                </p>
                <p>
                    4. The User shall not interfere with, alter, amend, tamper
                    with or misuse in any manner whatsoever the online services
                    and in the event of any damage or loss due to improper or
                    fraudulent use by the User, it shall be liable itself.
                </p>
                <p>
                    5.The technology for enabling the online services can be
                    affected by virus or other malicious, destructive or
                    corrupting code, programme or interceptions. This could
                    result in delays in the processing of Instructions or
                    failure in the processing of Instructions and other such
                    failures and inabilities. The User shall not hold JSIL
                    liable for any such instance. Delays may also be caused as a
                    result of, inter alia:
                </p>
                <p>
                    a. electrical breakdown disrupting the online services
                    connection; <br />
                    b. web browser shutting down before receipt of confirmation
                    of the Instruction from the User; <br />
                    c. dispute over the authenticity of the User’s signature or
                    any incorrect detail submitted by the User or any other
                    error made by the User; and<br />
                    d. multiple investments simultaneously made by the User.
                </p>
                <p>
                    In the event of any dispute arising between the User and
                    JSIL as a result of any of the aforesaid circumstances
                    resulting in a delay, the dispute shall be resolved through
                    the mechanism provided in Clause ‘7’ pertaining to Governing
                    Law.
                </p>
                <p>
                    6. The User understands and accepts that the offer price or
                    redemption price of units of the Funds may change from time
                    to time and that JSIL shall not be responsible or held
                    liable for quoting or misquoting any price whatsoever.
                </p>
                <p>
                    7. The User acknowledges having read and understood these
                    Terms and Conditions.
                </p>
                <p>
                    8. JSIL shall not be liable for any loss or damage to the
                    User as a result of making or not making the online services
                    available to the User, including direct, indirect,
                    consequential or special loss, even if JSIL has been advised
                    of the same. Circumstances where JSIL will not be liable
                    will include (but not be limited to):
                </p>
                <p>
                    a. acting on Instructions received by JSIL through the use
                    of the Password; <br />b. any reliance on financial
                    information provided as part, or by means of, the online
                    services; and <br />
                    c. loss or distortion of data during transmission or other
                    faults in the telecommunication network or a network
                    failure.
                </p>
                <p>
                    9. The contents on the online services are for convenience
                    and information purposes only. The User should consult its
                    financial, tax and legal advisors, and independently verify
                    all content provided through the online services before it
                    makes decisions. Nothing in these Terms and Conditions or on
                    the online services constitutes an offer to sell or buy any
                    product. Nothing on the online services or in these Terms
                    and Conditions should be construed as rendering tax, legal,
                    investment or accounting advice. The posting of any
                    prospectus or any other information on the online services
                    or these Terms and Conditions are not a recommendation or
                    opinion for the User to buy or sell any product or
                    participate in any transaction.
                </p>
                <p>
                    10. In addition to and without limiting the foregoing, JSIL
                    shall not be liable for any harm caused by the transmission,
                    through the services or information, of a computer virus, or
                    other computer code or programming device that might be used
                    to access, modify, delete, damage, corrupt, deactivate,
                    disable, disrupt, or otherwise impede in any manner the
                    operation of the services or any of the User’s software,
                    hardware, data or property.
                </p>
                <p>
                    11. JSIL will not allocate an account number to a User and
                    will not transfer Units in its name unless JSIL has
                    completed its KYC procedures and verified the information
                    submitted by the User and the User has paid the purchase
                    price.
                </p>
                <p>
                    12. JSIL reserves the right to take legal action against
                    those Users committing or attempting to commit online
                    frauds.
                </p>
                <p>
                    13. The Unit Holder accepts all debits made to the Account
                    arising from use of online services without limitation
                    (except after written notice of loss has been received and
                    acknowledged by JSIL/the Bank).
                </p>
                <h5>6. Indemnity</h5>
                <p>
                    1. The User indemnifies and agrees to keep JSIL, including
                    its officers, employees and agents, at all times saved,
                    defended, harmless and indemnified from and against any and
                    all loss, costs, outgoings, expenses, claims, actions,
                    damages or consequences whatsoever on a full indemnity basis
                    that they may suffer as a result of or in consequence of
                    JSIL providing the online services or arising out of the
                    User’s use of the online services.
                </p>
                <h5>7. Governing Law</h5>
                <p>
                    1. The validity, construction and performance of these Terms
                    and Conditions shall be governed by and be interpreted in
                    accordance with the laws of the Pakistan. These terms and
                    conditions are irrevocably agreed that the courts of
                    Pakistan at Karachi, shall have jurisdiction to settle any
                    disputes which may arise out of or in connection with usage
                    of Online Services and that accordingly any suit, action or
                    proceeding(s) arising out of or in connection with these
                    services will be brought at Karachi for resolution or
                    arbitration of the dispute.
                </p>
                <h5>8. Waiver</h5>
                <p>
                    1. No forbearance, delay or indulgence by JSIL in enforcing
                    the provision of these Terms and Conditions between JSIL and
                    the User shall prejudice or restrict the rights of JSIL nor
                    shall any waiver of its rights in relation to a breach of
                    these Terms and Conditions operate as a waiver of any
                    subsequent breach and no right, power or remedy given to or
                    reserved to the JSIL under the agreement is exclusive of any
                    other right, power or remedy available to JSIL and each such
                    right, power or remedy shall be cumulative.
                </p>
                <h5>9. Severability</h5>
                <p>
                    1. If any provision of these Terms and conditions is held to
                    be ineffective, unenforceable or illegal for any reason,
                    such decision shall not affect the validity or
                    enforceability of any or all of the remaining provisions of
                    these Terms and Conditions
                </p>
                <h5>10. Trade Marks and Copyright</h5>
                <p>
                    1. Copyright of the pages, screens, information, and all
                    material in their arrangement included in online services is
                    owned by or licensed to JSIL unless otherwise stated. You
                    may imprint, copy, download or temporarily store extracts
                    from our services for your personal information or when you
                    use our products and services. You must not alter anything
                    or distribute it to others. Any other use is prohibited
                    unless you first get our written permission. In particular
                    no one may use our screens or any part of our screens on any
                    other website, or link any other website to our services,
                    without our prior written permission. Unauthorized use of
                    these extracts may give rise to a claim for damages and/or
                    be a criminal offence.
                </p>
                <h5>11. Deductions</h5>
                <p>
                    1. Sales load deduction at the time of transaction will be
                    in conformity with applicable regulations, and as per
                    relevant constitutive documents of Funds/plans.
                </p>
                <p>
                    2. Other charges if any as per the constitutive documents of
                    the funds / plans or as per JSIL policy may be applicable on
                    transactions.
                </p>
                <p>
                    3. Zakat will be deducted at the time of redemption of units
                    if a duly filled and signed Zakat Affidavit Form is not
                    provided to the JSIL before 1st of Ramzan. It will be the
                    investors' responsibility to provide the Zakat Affidavit
                    before 1st of Ramzan if he/she wishes that Zakat may not be
                    deducted. It is also the investors' responsibility to
                    confirm if Zakat status is marked as 'Not Applicable' in the
                    JSIL’s records if the Affidavit has been submitted.
                </p>
                <p>
                    4. Any taxes including capital gain tax against redemption,
                    conversion or account to account transfer (change in
                    ownership) and/or withholding taxes on dividend shall be
                    applicable and deducted at source as per applicable laws.
                </p>
            </div>
            <div
                class="terms-and-conditions mb-3"
                v-on:scroll="handleScroll"
                v-else
            >
                <h4>
                    These terms and conditions (“Terms and Conditions”) regulate
                    the online services offered by JS Investments Limited also
                    referred as “JSIL” for the Funds to the Users.
                </h4>

                <p>
                    Whereas, JSIL is offering the digital account opening
                    services and online transactions in compliance with the
                    regulatory requirements pursuant to the constitutive
                    documents of the Funds, to facilitate investment and
                    divestment by Unit Holders/ Account Holders and to make
                    adequate arrangements for receiving and processing
                    applications in this regard.
                </p>
                <h5>1. General</h5>
                <p>
                    1. By receiving the automatically generated password for the
                    first log in to the online services, the User is deemed to
                    have acknowledged that it has read, reviewed, understood and
                    unconditionally and irrevocably accepted all these Terms and
                    Conditions. These Terms and Conditions form the contract
                    between the User and JSIL for the use of the online
                    services. These Terms and Conditions are in addition to and
                    not in derogation of the Constitutive Documents for the
                    relevant Fund(s) of which the User is a Unit Holder and
                    shall be construed in accordance with the applicable law and
                    regulations from time to time. JSIL shall have the absolute
                    discretion to amend or supplement any of these Terms and
                    Conditions pertaining to the online services at any time and
                    shall be notified by hosting the same on the website of JSIL
                    or in any other manner as decided by JSIL. Such amended
                    Terms and Conditions stipulated by JSIL will thereupon apply
                    to and be binding on the User. The User shall be responsible
                    for regularly reviewing these Terms and Conditions,
                    including amendments thereto as may be posted on the website
                    of JSIL.
                </p>
                <p>
                    2. The User shall have no objection to JSIL verifying the
                    User’s identity before registering the User for online
                    services. The User shall register for online services by
                    providing such personal details as shall be required by JSIL
                    from time to time for the purpose of effecting the
                    registration. JSIL shall validate the personal details
                    provided by the User to enable the User to register for the
                    online services. In the event that any of the details
                    provided by the User are not in conformity with the details
                    available with JSIL, JSIL shall, at its sole discretion,
                    reject the registration of the User and the User may be
                    required to update its personal details with JSIL in the
                    manner prescribed by JSIL. In the event of incorrect
                    submission of details by the User or the User failing the
                    KYC procedures, its account may also be blocked and any
                    payment made shall be returned or the Units purchased shall
                    be redeemed, as the case may be, to the User by transferring
                    the amount to the account from which the payment was made
                </p>
                <p>
                    3. In case of any discrepancy in the details of any
                    transaction carried out in respect of the User's online
                    services, the User shall be obliged to intimate to JSIL
                    thereof in writing within 7 (seven) days of receipt of the
                    statement of account. In the event of the User failing to
                    intimate, the statement of account will be deemed to be
                    correct and accepted by the User.
                </p>
                <p>
                    4. JSIL is authorized to provide any information or details
                    relating to the User, its account(s) of the relevant Fund(s)
                    or its Account(s) to any third person so far as is necessary
                    to give effect to any instructions or to comply with any
                    order of the Court or of any competent/ statutory authority
                    or as is required under applicable law
                </p>
                <p>
                    5. The User hereby confirms that the User shall solely be
                    responsible for conducting all activities by using the
                    Services and Password over the online services and the same
                    will be deemed to have emanated from such User. The User
                    agrees that all Instructions transmitted by using the online
                    services, shall be deemed to be written instructions and
                    agrees not to dispute or challenge the validity or
                    enforceability of any such instruction on the grounds that
                    such instructions were not written documents and hereby
                    waives any such right the User may have at law. In addition,
                    such Instructions are considered original documents and the
                    User agrees not to challenge the admissibility of any such
                    instruction on the grounds that it is made in electronic or
                    oral form.
                </p>
                <p>
                    6. The User represents to JSIL that the User has full power
                    to perform its obligations in accordance with these Terms
                    and Conditions and availing the online services.
                </p>
                <p>
                    7. The User agrees that the online services is being
                    provided by JSIL for the User’s benefit and in discharge of
                    the duty imposed upon JSIL to facilitate investment and
                    divestment by Unit Holders and to make adequate arrangements
                    for receiving and processing applications in this regard.
                    The User further acknowledges that JSIL has the power to
                    provide the online services pursuant to the Constitutive
                    Documents and the transactions envisaged by the online
                    services along with these Terms and Conditions shall be
                    legal, valid and binding and in accordance with the
                    provisions of the Constitutive Documents.
                </p>
                <p>
                    8. In order to have a valid transaction, where the User is
                    not resident in Pakistan or the person to whom the User
                    intends to transfer its Units, is not resident in Pakistan,
                    the User agrees to ensure that the information on the
                    Proceeds Realization Certificate(s) matches the details of
                    the User’s online services.
                </p>
                <p>
                    9. The User agrees to avoid transfer of cash or third
                    payments to JSIL Funds accounts as Cash and third Party
                    Payments are NOT acceptable for investment in JSIL Funds.
                </p>
                <p>
                    10. The Unit Holder accepts that all transactions effected
                    through use of the online services shall be binding jointly
                    and severally on all joint Unit Holders.
                </p>
                <p>
                    11. Statutory Details - Users may obtain constitutive
                    documents along with application forms from the offices of
                    JSIL or can be downloaded from the company website
                    accessible at www.jsil.com.
                </p>
                <p>
                    12. Risk Factors - All investments in mutual funds and
                    securities are subject to market risks and the Net Asset
                    Value (NAV) of the Scheme(s) may go up or down depending on
                    the factors and forces affecting the securities markets.
                    There can be no assurance that the objectives of the
                    Scheme(s) will be achieved. Past performance of the Sponsor,
                    AMC, Mutual Fund or any associates of the Sponsor/AMC does
                    not indicate the future performance of the Scheme(s) of the
                    Mutual Fund.
                </p>
                <h5>2. Service</h5>
                <p>
                    1. The User acknowledges that the price, rates, conditions
                    and charges applicable for a Service shall be in accordance
                    with the applicable Constitutive Documents and susceptible
                    to change in accordance with the terms thereof.
                </p>
                <p>
                    2. The User acknowledges and undertakes that if
                    transaction(s) is submitted after cut off time as mentioned
                    in respective Constitutive Documents of the Funds, that
                    transaction(s) will be processed on next working day and
                    that he/she will not hold JSIL or trustee of the respective
                    Fund for any loss consequent to processing of such
                    transaction(s) on the next working day.
                </p>
                <p>
                    3. The calculation of the NAV for investment and redemption
                    transactions will be done in accordance with the
                    Constitutive Documents.
                </p>
                <p>
                    4. The Unit Holder agrees that number of units shall be
                    issued on realization of investment amounts in Funds bank
                    account(s) as per relevant pricing mechanism of the Fund in
                    accordance with the Constitutive Documents.
                </p>
                <p>
                    5. The User understands that the online services shall be
                    provided at the sole discretion of JSIL who may, at its
                    absolute discretion, alter, suspend or terminate any of the
                    services or online services completely or partially without
                    any notice to the User and without assigning any reasons
                    thereof and the User agrees that JSIL will not be liable for
                    any consequences in connection thereof. JSIL reserves the
                    right, in its sole discretion, to withdraw any or all the
                    Funds from the online services with prior notice published
                    on its website without assigning any reason for such
                    withdrawal of Fund.
                </p>
                <p>
                    6. The User may close his online services by contacting JSIL
                    or providing written instructions to the effect to close the
                    account.
                </p>
                <p>
                    7. The User consents that persons authorized by it may give
                    an Instruction or use a Service on its behalf. The User
                    accepts all risks in connection with such third party use
                    and further and accepts that JSIL shall not be liable in any
                    manner and for any reason whatsoever in connection with such
                    third party use on behalf of the User. In the event of an
                    unauthorized person using a Service or giving an
                    unauthorized Instruction, the User shall inform JSIL of such
                    fact not later than 12 hours after receiving a notification
                    from JSIL that the account has been accessed.
                </p>
                <p>
                    8. Any redemption request would be processed subject to the
                    closing Units available in JSIL's records.
                </p>
                <p>
                    9. In the event that there is insufficient number of Units
                    lying to the Unit Holder’s credit in its account with JSIL
                    or the drawing limit is exhausted or insufficient funds are
                    lying in the Account, no fund transfer will be allowed.
                </p>
                <p>
                    10. Our products and services are offered only in
                    jurisdictions where and when they may be lawfully offered
                    and the material on JSIL website or online services is not
                    intended for use by persons located in or resident in
                    jurisdictions which restrict the distribution of this
                    material by us. Persons accessing these pages are required
                    to inform themselves about and observe any relevant
                    restrictions.
                </p>

                <h5>3. Security and Confidentiality of Information</h5>

                <p>
                    1. The Password selected by the User is confidential in
                    nature and the User confirms that it will keep the Password
                    confidential and will not divulge it to anybody else except
                    for the purpose of using it himself for availing of any
                    facilities as may be offered by JSIL under online services
                    from time to time. The User also agrees to take all possible
                    care to prevent discovery of the Password by any other
                    person. The responsibility for misuse of the Password of the
                    User is solely of the User and JSIL shall not be responsible
                    for the use/misuse of the Password in any manner whatsoever.
                    Accordingly, the User agrees to accept the activities
                    conducted through the use/misuse of or fraudulent use of the
                    Password of the User in the same manner as if such
                    activities were duly authorized by the User itself.
                </p>
                <p>
                    2. The User confirms and assures that it will not share its
                    Password with any person(s). Notwithstanding the aforesaid,
                    in the event of the User sharing its Password with any other
                    person(s), for availing any facilities offered by JSIL under
                    online services, then for such disclosure and any
                    consequences of use / misuse of Password by such person(s),
                    the User shall be solely responsible. JSIL shall never
                    contact the User to inquire about his/her password.
                </p>
                <p>
                    3. The User shall inform JSIL immediately in case its
                    Password becomes known to any other person or is lost. JSIL
                    may in its absolute discretion, issue to the User a new
                    Password on similar terms and conditions or under such terms
                    and conditions as JSIL may deem fit.
                </p>
                <p>
                    4. The User is aware of all security risks including
                    possible third party interception of its account and the
                    content of it account becoming known to third parties. The
                    User accepts that the use of the online services is not the
                    most secure method of accepting and transmitting information
                    and that it involves security hazards and the risk of any
                    loss of information or obtaining of information by any third
                    party will be to its account and JSIL shall, in no way, be
                    held responsible for the same and this shall not be
                    considered as a breach of its or its constituent company
                </p>
                <p>
                    5. A User’s access to online services will be disabled if a
                    wrong Password or identification information is entered
                    successively for 3 times or as decided by JSIL in its sole
                    discretion from time to time.
                </p>
                <p>
                    6. The User shall ensure that the title of its bank account
                    from which investment amount will be paid and to which
                    redemption proceeds will be paid, shall be the same as the
                    title of its online services to achieve an additional level
                    of security.
                </p>

                <h5>4. Online Payments</h5>
                <p>
                    1. The online payment system is provided by JSIL and its
                    third party suppliers. The User warrants that in using the
                    online payment facility it is authorized to use such
                    facility for the payment or payments it is making. JSIL may
                    provide more than one facility for making online payments.
                </p>
                <p>
                    2. JSIL will not be liable if a payment transaction cannot
                    be processed as a result of (i) a legal order prohibiting
                    withdrawals from the Account, (ii) the Account is dormant,
                    closed or has been inactive, (iii) JSIL is otherwise not
                    authorized to debit the Account due to some legal orders,
                    (iv) Units in the accounts are pledged or lien is marked in
                    favour of some pledgee. or (v) the Unit Holder providing an
                    incorrect account number or other incorrect details whether
                    personal or otherwise. The Unit Holder agrees that JSIL
                    shall not be liable for any costs, fees, loss or damage in
                    the event it fails to process an Instruction where payment
                    has been made by using the Transfer in the correct amount or
                    in a timely manner when properly instructed to do so by the
                    Unit Holder, except where (a) the Account has insufficient
                    funds, (b) the funds are subject to legal process or other
                    encumbrance restricting such Transfer or (d) as otherwise
                    provided in instructions by the State Bank of Pakistan.
                </p>
                <p>
                    3. JSIL reserves the right to refuse to honor payment
                    requests that it believes or suspects (rightly or wrongly)
                    are fraudulent or erroneous. The Unit Holder understands,
                    however, that JSIL’s exercise of this right will be in its
                    sole discretion and the Unit Holder should not rely on JSIL
                    to discover or prevent loss as a result of a fraud or
                    erroneous payments.
                </p>

                <h5>5. Liability</h5>
                <p>
                    1. JSIL shall have no obligation to verify the authenticity
                    of any Activity conducted, Service used or Instruction
                    received or purported to have been received from the User
                    other than by means of verification of the Password. The
                    User shall directly contact JSIL for any fraudulent
                    transaction(s) on account of misuse of the online services
                    by a fraudulent individual/party and such issues shall be
                    suitably addressed by JSIL alone in line with its policies
                    and rules. The User agrees that under no circumstances shall
                    JSIL be liable for such fraudulent transactions.
                </p>
                <p>
                    2. The User understands that JSIL disclaims all and any
                    liability, whether direct or indirect, whether arising out
                    of loss of profit or otherwise arising out of any failure or
                    inability by JSIL to honor any instruction from the User for
                    whatsoever reason. The User understands and accepts that
                    JSIL shall not be responsible for any of the risks. The User
                    also accepts that JSIL has disclaimed all liability in
                    respect of the said risks. The Unit Holder accepts that
                    there may be delays in processing Instructions for
                    investment or redemption of Units due to the infrastructure,
                    connectivity and services provided by the network service
                    providers and other factors, including unavailability of
                    funds in the Account or delays by the User’s banks and/or
                    financial institutions. As a result, while the User may give
                    an Instruction before the cut-off timings on a business day,
                    the same may be processed after the cut-off timings and in
                    calculating the NAV, the following business day’s rates
                    shall be applicable. The User shall not hold JSIL liable for
                    any such instance.
                </p>
                <p>
                    3. The User acknowledges that the online services is
                    dependent on the infrastructure, connectivity and services
                    provided by the network service providers and other factors.
                    The User accepts that timeliness, accuracy and readability
                    of SMS/alerts/information shall depend on factors affecting
                    the network service providers. JSIL shall not be liable for
                    non-delivery or delayed delivery of
                    SMS/alerts/instructions/information, payments, error, loss
                    or distortion in transmission of information and
                    Instructions to/from the User.
                </p>
                <p>
                    4. The User shall not interfere with, alter, amend, tamper
                    with or misuse in any manner whatsoever the online services
                    and in the event of any damage or loss due to improper or
                    fraudulent use by the User, it shall be liable itself.
                </p>
                <p>
                    5.The technology for enabling the online services can be
                    affected by virus or other malicious, destructive or
                    corrupting code, programme or interceptions. This could
                    result in delays in the processing of Instructions or
                    failure in the processing of Instructions and other such
                    failures and inabilities. The User shall not hold JSIL
                    liable for any such instance. Delays may also be caused as a
                    result of, inter alia:
                </p>
                <p>
                    a. electrical breakdown disrupting the online services
                    connection; <br />
                    b. web browser shutting down before receipt of confirmation
                    of the Instruction from the User; <br />
                    c. dispute over the authenticity of the User’s signature or
                    any incorrect detail submitted by the User or any other
                    error made by the User; and<br />
                    d. multiple investments simultaneously made by the User.
                </p>
                <p>
                    In the event of any dispute arising between the User and
                    JSIL as a result of any of the aforesaid circumstances
                    resulting in a delay, the dispute shall be resolved through
                    the mechanism provided in Clause ‘7’ pertaining to Governing
                    Law.
                </p>
                <p>
                    6. The User understands and accepts that the offer price or
                    redemption price of units of the Funds may change from time
                    to time and that JSIL shall not be responsible or held
                    liable for quoting or misquoting any price whatsoever.
                </p>
                <p>
                    7. The User acknowledges having read and understood these
                    Terms and Conditions.
                </p>
                <p>
                    8. JSIL shall not be liable for any loss or damage to the
                    User as a result of making or not making the online services
                    available to the User, including direct, indirect,
                    consequential or special loss, even if JSIL has been advised
                    of the same. Circumstances where JSIL will not be liable
                    will include (but not be limited to):
                </p>
                <p>
                    a. acting on Instructions received by JSIL through the use
                    of the Password; <br />b. any reliance on financial
                    information provided as part, or by means of, the online
                    services; and <br />
                    c. loss or distortion of data during transmission or other
                    faults in the telecommunication network or a network
                    failure.
                </p>
                <p>
                    9. The contents on the online services are for convenience
                    and information purposes only. The User should consult its
                    financial, tax and legal advisors, and independently verify
                    all content provided through the online services before it
                    makes decisions. Nothing in these Terms and Conditions or on
                    the online services constitutes an offer to sell or buy any
                    product. Nothing on the online services or in these Terms
                    and Conditions should be construed as rendering tax, legal,
                    investment or accounting advice. The posting of any
                    prospectus or any other information on the online services
                    or these Terms and Conditions are not a recommendation or
                    opinion for the User to buy or sell any product or
                    participate in any transaction.
                </p>
                <p>
                    10. In addition to and without limiting the foregoing, JSIL
                    shall not be liable for any harm caused by the transmission,
                    through the services or information, of a computer virus, or
                    other computer code or programming device that might be used
                    to access, modify, delete, damage, corrupt, deactivate,
                    disable, disrupt, or otherwise impede in any manner the
                    operation of the services or any of the User’s software,
                    hardware, data or property.
                </p>
                <p>
                    11. JSIL will not allocate an account number to a User and
                    will not transfer Units in its name unless JSIL has
                    completed its KYC procedures and verified the information
                    submitted by the User and the User has paid the purchase
                    price.
                </p>
                <p>
                    12. JSIL reserves the right to take legal action against
                    those Users committing or attempting to commit online
                    frauds.
                </p>
                <p>
                    13. The Unit Holder accepts all debits made to the Account
                    arising from use of online services without limitation
                    (except after written notice of loss has been received and
                    acknowledged by JSIL/the Bank).
                </p>
                <h5>6. Indemnity</h5>
                <p>
                    1. The User indemnifies and agrees to keep JSIL, including
                    its officers, employees and agents, at all times saved,
                    defended, harmless and indemnified from and against any and
                    all loss, costs, outgoings, expenses, claims, actions,
                    damages or consequences whatsoever on a full indemnity basis
                    that they may suffer as a result of or in consequence of
                    JSIL providing the online services or arising out of the
                    User’s use of the online services.
                </p>
                <h5>7. Governing Law</h5>
                <p>
                    1. The validity, construction and performance of these Terms
                    and Conditions shall be governed by and be interpreted in
                    accordance with the laws of the Pakistan. These terms and
                    conditions are irrevocably agreed that the courts of
                    Pakistan at Karachi, shall have jurisdiction to settle any
                    disputes which may arise out of or in connection with usage
                    of Online Services and that accordingly any suit, action or
                    proceeding(s) arising out of or in connection with these
                    services will be brought at Karachi for resolution or
                    arbitration of the dispute.
                </p>
                <h5>8. Waiver</h5>
                <p>
                    1. No forbearance, delay or indulgence by JSIL in enforcing
                    the provision of these Terms and Conditions between JSIL and
                    the User shall prejudice or restrict the rights of JSIL nor
                    shall any waiver of its rights in relation to a breach of
                    these Terms and Conditions operate as a waiver of any
                    subsequent breach and no right, power or remedy given to or
                    reserved to the JSIL under the agreement is exclusive of any
                    other right, power or remedy available to JSIL and each such
                    right, power or remedy shall be cumulative.
                </p>
                <h5>9. Severability</h5>
                <p>
                    1. If any provision of these Terms and conditions is held to
                    be ineffective, unenforceable or illegal for any reason,
                    such decision shall not affect the validity or
                    enforceability of any or all of the remaining provisions of
                    these Terms and Conditions
                </p>
                <h5>10. Trade Marks and Copyright</h5>
                <p>
                    1. Copyright of the pages, screens, information, and all
                    material in their arrangement included in online services is
                    owned by or licensed to JSIL unless otherwise stated. You
                    may imprint, copy, download or temporarily store extracts
                    from our services for your personal information or when you
                    use our products and services. You must not alter anything
                    or distribute it to others. Any other use is prohibited
                    unless you first get our written permission. In particular
                    no one may use our screens or any part of our screens on any
                    other website, or link any other website to our services,
                    without our prior written permission. Unauthorized use of
                    these extracts may give rise to a claim for damages and/or
                    be a criminal offence.
                </p>
                <h5>11. Deductions</h5>
                <p>
                    1. Sales load deduction at the time of transaction will be
                    in conformity with applicable regulations, and as per
                    relevant constitutive documents of Funds/plans.
                </p>
                <p>
                    2. Other charges if any as per the constitutive documents of
                    the funds / plans or as per JSIL policy may be applicable on
                    transactions.
                </p>
                <p>
                    3. Zakat will be deducted at the time of redemption of units
                    if a duly filled and signed Zakat Affidavit Form is not
                    provided to the JSIL before 1st of Ramzan. It will be the
                    investors' responsibility to provide the Zakat Affidavit
                    before 1st of Ramzan if he/she wishes that Zakat may not be
                    deducted. It is also the investors' responsibility to
                    confirm if Zakat status is marked as 'Not Applicable' in the
                    JSIL’s records if the Affidavit has been submitted.
                </p>
                <p>
                    4. Any taxes including capital gain tax against redemption,
                    conversion or account to account transfer (change in
                    ownership) and/or withholding taxes on dividend shall be
                    applicable and deducted at source as per applicable laws.
                </p>
                <!-- <hr /> -->
            </div>

            <popup-button
                btn-type="button"
                btn-variant="primary"
                btn-label="I Agree"
                :class="loading ? 'disabled' : ''"
                :disabled="loading"
                @onClickButton="agreeToTermsAndConditions"
            ></popup-button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import PopupButton from '@/components/registration/PopupButton.vue'
import Checkbox from '@/components/registration/Checkbox.vue'

export default {
    components: {
        PopupButton,
        Checkbox,
    },
    data() {
        return {
            // btnDisabled: true,
            // status: 'not_accepted',
            field: {
                key: 'recieveOtpOption',
                isLocked: true,
                isRequired: true,
                isDisabled: false,
                options: [
                    {
                        text: 'sms',
                        value: 'sms',
                    },
                    {
                        text: 'email',
                        value: 'email',
                    },
                ],
                label: 'You want to receive OTP as',
                title: 'You want to receive OTP as',
            },
        }
    },

    mounted() {
        let isd = this.$store.state.registration.form.contactInfo.isdCode
        // console.log("isd is ", isd)
        if (isd !== '+92') {
            // this.field.isDisabled = true
            this.field.options.splice(0, 1)
            var opt = ['email']
            this.$store.commit('updateField', {
                key: 'recieveOtpOption',
                value: opt,
            })
        }
    },

    methods: {
        handleScroll() {
            var textElement = document.querySelector('.terms-and-conditions')
            if (
                textElement.scrollTop + textElement.offsetHeight >=
                textElement.scrollHeight
            ) {
                // document.getElementsByName('button')[0].disabled = false
                // this.btnDisabled = false
            }
        },
        agreeToTermsAndConditions() {
            //console.log('Terms', this.$store.state.registration.form)
            // let data = this.$store.state.registration.form.recieveOtpOption
            // if (data && data.length && data.length > 0) {
            this.$emit('agreed')
            // } else {
            //     let msg = this.field.title + ' field is required'
            //     this.$store.commit('setError', msg)
            // }
        },
    },
    computed: {
        ...mapGetters(['loading']),

        isUrdu() {
            let lang = this.$store.getters.getField('languageOption')
            if (lang == 'urd') {
                return true
            }
        },
    }, // End of Component > methods
}
</script>

<style scoped>
.wrapper {
    height: 68vh;
    padding: 20px;
    border: 1px solid #80808033;
    background: #fff;
    display: grid;
    grid-template-rows: 1fr auto;
    overflow-x: hidden;
}
.terms-and-conditions {
    overflow: scroll;
    overflow-x: hidden;
}
</style>
